export const getPortfolioRoleName = (
  role: { name: string } | { name: string }[] | null | undefined
): string | undefined => (Array.isArray(role) ? role[0]?.name : role?.name)
